





























import { Mixins, Component } from 'vue-property-decorator'
import { CurrentAdminManager } from '@/mixins/current-admin-manager'

@Component({
  components: {
    SmText: () => import('@/components/atoms/SmText.vue'),
    SmTemplate: () => import('@/components/templates/SmTemplate.vue'),
  }
})
export default class FileNamingRulesPage extends Mixins(CurrentAdminManager) {
}
